var EnrollmentNameValuePairs_1;
import { __decorate } from "tslib";
import { AsnArray, AsnType, AsnTypeTypes, AsnProp, AsnPropTypes } from "@peculiar/asn1-schema";
export const id_enrollmenNameValuePair = "1.3.6.1.4.1.311.13.2.1";
export class EnrollmentNameValuePair {
    constructor(params = {}) {
        this.name = "";
        this.value = "";
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: AsnPropTypes.BmpString })
], EnrollmentNameValuePair.prototype, "name", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.BmpString })
], EnrollmentNameValuePair.prototype, "value", void 0);
let EnrollmentNameValuePairs = EnrollmentNameValuePairs_1 = class EnrollmentNameValuePairs extends AsnArray {
    constructor(items) {
        super(items);
        Object.setPrototypeOf(this, EnrollmentNameValuePairs_1.prototype);
    }
};
EnrollmentNameValuePairs = EnrollmentNameValuePairs_1 = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence, itemType: EnrollmentNameValuePair })
], EnrollmentNameValuePairs);
export { EnrollmentNameValuePairs };
